export enum AccountModalActions {
  closeAccountModal = 'closeAccountModal',
  openCreateAccountModal = 'openCreateAccountModal',
  openForgotPasswordModal = 'openForgotPasswordModal',
  openLogInModal = 'openLogInModal',
  openResetPasswordModal = 'openResetPasswordModal',
  redirect = 'redirect',
  setCallbackFunction = 'setCallbackFunction',
  setButtonText = 'setButtonText',
  setGuestEmail = 'setGuestEmail',
  setPasswordResetToken = 'setPasswordResetToken',
  setSubtitle = 'setSubtitle',
  setTitle = 'setTitle',
  triggerCaptcha = 'triggerCaptcha',
}

type IAccountModalAction =
  | { type: AccountModalActions.closeAccountModal; payload?: string }
  | { type: AccountModalActions.openCreateAccountModal; payload?: string }
  | { type: AccountModalActions.openForgotPasswordModal; payload?: string }
  | { type: AccountModalActions.openLogInModal; payload?: string }
  | { type: AccountModalActions.openResetPasswordModal; payload?: string }
  | { type: AccountModalActions.redirect; payload?: string }
  | { type: AccountModalActions.setCallbackFunction; payload?: () => void }
  | { type: AccountModalActions.setButtonText; payload?: string }
  | { type: AccountModalActions.setGuestEmail; payload?: string }
  | { type: AccountModalActions.setPasswordResetToken; payload?: string }
  | { type: AccountModalActions.setSubtitle; payload?: string }
  | { type: AccountModalActions.setTitle; payload?: string }
  | { type: AccountModalActions.triggerCaptcha; payload?: string };

type IAccountModalContext = 'logIn' | 'createAccount' | 'forgotPassword' | 'resetPassword' | null;

export interface IAccountModalState {
  buttonText: string | null;
  callbackFunction: () => void | null;
  guestEmail?: string;
  hideToggleLink: boolean;
  modalContext: IAccountModalContext | null;
  passwordResetToken: string | null;
  redirect: string | null;
  showCaptcha: boolean;
  subtitle: string | null;
  title: string | null;
}

export const INITIAL_ACCOUNT_MODAL_STATE: IAccountModalState = {
  buttonText: null,
  callbackFunction: null,
  hideToggleLink: false,
  modalContext: null,
  passwordResetToken: null,
  redirect: null,
  showCaptcha: false,
  subtitle: null,
  title: null,
};

export const accountModalReducer = (state: IAccountModalState, action: IAccountModalAction) => {
  switch (action.type) {
    case AccountModalActions.closeAccountModal:
      state.modalContext = null;
      break;
    case AccountModalActions.openCreateAccountModal:
      state.modalContext = 'createAccount';
      break;
    case AccountModalActions.openForgotPasswordModal:
      state.modalContext = 'forgotPassword';
      break;
    case AccountModalActions.openLogInModal:
      state.modalContext = 'logIn';
      state.hideToggleLink = action?.payload === 'hideToggleLink';
      break;
    case AccountModalActions.openResetPasswordModal:
      state.modalContext = 'resetPassword';
      break;
    case AccountModalActions.redirect:
      state.redirect = action?.payload;
      break;
    case AccountModalActions.setButtonText:
      state.buttonText = action?.payload;
      break;
    case AccountModalActions.setGuestEmail:
      state.guestEmail = action?.payload;
      break;
    case AccountModalActions.setSubtitle:
      state.subtitle = action?.payload;
      break;
    case AccountModalActions.setTitle:
      state.title = action?.payload;
      break;
    case AccountModalActions.setPasswordResetToken:
      state.passwordResetToken = action?.payload;
      break;
    case AccountModalActions.triggerCaptcha:
      state.showCaptcha = action.payload === 'on';
      break;
    case AccountModalActions.setCallbackFunction:
      state.callbackFunction = action?.payload;
      break;

    default:
      return state;
  }
  return state;
};
